/**
 * Queue Jobs API Endpoints
 * Framework-agnostic endpoint definitions for queue jobs module
 * All endpoints require program_id query parameter
 */

export const QUEUE_JOBS_ENDPOINTS = {
  /** Get paginated list of queue job logs for the selected program */
  list: 'queue/job-logs',
} as const;
